export default __webpack_public_path__ + "s8.png";